
import {tap} from 'rxjs/operators';
import { Observable } from 'rxjs';

import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';

import { CguTypeEnum } from '../../../shared/components/conditions-generales/cgu.model';
import { DepotRequeteState } from '../../depot-requete-state.model';
import { DraftDepotRequeteService } from '../../draft-depot-requete.service';

@Component({
    templateUrl: './avertissement.component.html',
    styleUrls: ['avertissement.component.scss']
})
export class AvertissementComponent implements OnInit, AfterViewInit {
    isSubmitted = false;

    // For validation only
    _cgu = false;
    _teleprocedures = false;

    cguTypeEnum = CguTypeEnum.CGU_DEPOT_REQUETE;

    @Output() previousStep: EventEmitter<any> = new EventEmitter();
    @Output() nextStep: EventEmitter<any> = new EventEmitter();
    @Output() hideAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showErrorAlertDraft: EventEmitter<any> = new EventEmitter();

    @ViewChild(NgForm) form: NgForm;

    constructor(private draftDepotRequeteService: DraftDepotRequeteService) {}

    ngOnInit(): void {
        this.hideAlertDraft.emit();
    }

    ngAfterViewInit() {
      document.getElementById('logo-link').focus();
    }

    next(): Observable<DepotRequeteState> {
        this.isSubmitted = true;
        if (this.form.valid) {
            return this.draftDepotRequeteService.acceptCgu().pipe(tap(
                () => {
                    this.nextStep.emit();
                },
                (error) => {
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                }
            ));
        }
    }

    previous(): void {
        this.previousStep.emit();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/avertissement/avertissement.component.ts